export default __webpack_public_path__ + "static/media/snitch.69c20398.png";